export const GET_HIGHLIGHTS_REQUEST = 'GET_HIGHLIGHTS_REQUEST';
export const GET_HIGHLIGHTS_SUCCESS = 'GET_HIGHLIGHTS_SUCCESS';
export const GET_HIGHLIGHTS_FAIL = 'GET_HIGHLIGHTS_FAIL';

export const SET_ANSWERED_INDEX = 'SET_ANSWERED_INDEX';

export const GET_TASKS_STATS_REQUEST = 'GET_TASKS_STATS_REQUEST';
export const GET_TASKS_STATS_SUCCESS = 'GET_TASKS_STATS_SUCCESS';
export const GET_TASKS_STATS_FAIL = 'GET_TASKS_STATS_FAIL';